export default __webpack_public_path__ + "static/Blind-angels-tony-video-6f767bd2bbafcc90c3eb75e5f02e7766.png";